<button class="btn" type="button"
  [ngClass]="classList"
  [disabled]="disabled"
  (click)="openLoginDialog()"
>
  <span class="btn__text">{{ title }}</span>
  @if (hasIcon) {
    <i [ngClass]="icon"></i>
  }
</button>
